module.exports = __webpack_public_path__ + "resources/img/img_docuone.f00ce8bf1c73708c5f6418a9ff2caf45.png";